//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../views/common-components/file-uploader';
import util from '@/lib/util';

export default {
    name: 'table-expand',
    props: {
        row: Object
    },
    components: {
        fileUploader
    },
    data() {
        return {
            downloadUrl: util.ApiUrl + '/file/download/'
        };
    },
    methods: {}
};
